module.exports = __webpack_public_path__ + "img/title.d1f59120.png";